module.exports = __webpack_public_path__ + "img/img_kiwoom_visual.81b55a71.png";